import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';
import { CollapsedPanelStateInitialState } from './types/collapsedPanelStateTypes';

export const initialState: CollapsedPanelStateInitialState = {
  panels: {},
};

export const collapsedPanelStateSlice = createSlice({
  name: 'collapsedPanelState',
  initialState,
  reducers: {
    togglePanelState: (state, action) => {
      state.panels[action.payload.panelId] =
        typeof state.panels[action.payload.panelId] === 'boolean'
          ? !state.panels[action.payload.panelId]
          : false;
    },
  },
});

export const { togglePanelState } = collapsedPanelStateSlice.actions;

// selectors
export const collapsedPanelStateSelectors = {
  selectCollapsedPanelStates: (state: RootState) =>
    state.collapsedPanelState.panels,
};

export default collapsedPanelStateSlice.reducer;
